export const toggleShowAddTaskInput = (projectid) => {
  return {
    type: 'TOGGLE_SHOW_ADD_TASK_INPUT',
    payload: {
      projectId: projectid,
    },
  };
};